export var MAX_WIDTH_DESKTOP = 400;
export var MARGIN_MOBILE = 16;
export var BREAKPOINT = MAX_WIDTH_DESKTOP + MARGIN_MOBILE * 2;
export var TEXT_FONT_SIZE = 'T100';
export var TEXT_FONT_WEIGHT = 'regular';
export var TEXT_COLOR = 'neutral90';